// Browser Notification Service für GrowManager

const STORAGE_KEY = 'gm_notification_settings';
const LAST_CHECK_KEY = 'gm_last_notification_check';

export function getNotificationSettings() {
  try {
    return JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}');
  } catch {
    return {};
  }
}

export function saveNotificationSettingsLocal(settings) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(settings));
}

export async function requestNotificationPermission() {
  if (!('Notification' in window)) return 'not-supported';
  if (Notification.permission === 'granted') return 'granted';
  if (Notification.permission === 'denied') return 'denied';
  const result = await Notification.requestPermission();
  return result;
}

export function isNotificationSupported() {
  return 'Notification' in window;
}

export function getCurrentPermission() {
  if (!('Notification' in window)) return 'not-supported';
  return Notification.permission;
}

export function sendBrowserNotification(title, body, icon = null) {
  if (!('Notification' in window) || Notification.permission !== 'granted') return;
  new Notification(title, {
    body,
    icon: icon || '/favicon.ico',
    badge: '/favicon.ico',
    tag: 'growmanager-reminder',
  });
}

// Check if it's time to send watering reminder
export function checkAndSendReminders(plants) {
  const settings = getNotificationSettings();
  if (!settings.enabled || Notification.permission !== 'granted') return;
  if (!plants || plants.length === 0) return;

  const now = new Date();
  const [reminderHour, reminderMin] = (settings.reminder_time || '08:00').split(':').map(Number);
  const lastCheck = localStorage.getItem(LAST_CHECK_KEY);
  const today = now.toDateString();

  // Only fire once per day
  if (lastCheck === today) return;

  // Check if current time matches reminder time (within 5 minutes)
  const isReminderTime = now.getHours() === reminderHour &&
    now.getMinutes() >= reminderMin && now.getMinutes() < reminderMin + 5;

  if (!isReminderTime) return;

  localStorage.setItem(LAST_CHECK_KEY, today);
  const intervalDays = settings.watering_interval_days || 2;

  // Find plants that need watering
  const overduePlants = plants.filter(plant => {
    if (!plant.last_care) return true;
    const lastWatered = new Date(plant.last_care.performed_at);
    const diffDays = (now - lastWatered) / (1000 * 60 * 60 * 24);
    return diffDays >= intervalDays && plant.last_care.care_type === 'watering';
  });

  if (overduePlants.length > 0) {
    sendBrowserNotification(
      `GrowManager: ${overduePlants.length} Pflanze(n) brauchen Wasser!`,
      `${overduePlants.slice(0, 3).map(p => p.name).join(', ')}${overduePlants.length > 3 ? ` und ${overduePlants.length - 3} weitere` : ''} müssen gegossen werden.`
    );
  }
}
